/** Props Interface */
interface ScrollIntoViewProps {
	id: string;
	timeout?: number;
	count?: number;
	behavior?: ScrollBehavior;
	inline?: ScrollLogicalPosition;
	block?: ScrollLogicalPosition;
}

export function scrollIntoView({
	id,
	timeout = 100,
	count = 0,
	behavior = "smooth",
	inline = "nearest",
	block = "center",
}: ScrollIntoViewProps) {
	if (count > 4) return;
	setTimeout(() => {
		try {
			const elements = document.querySelectorAll(`#${id}`);
			if (!elements.length) {
				return scrollIntoView({
					id,
					timeout,
					count: count + 1,
					behavior,
				});
			}
			for (const element of elements) {
				element.scrollIntoView({
					behavior,
					inline,
					block,
				});
				break;
			}
		} catch {}
	}, timeout);
}
